import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
// NG-UI
import {
	ZkCheckoutContainerModule,
	ZkCheckoutInviteFriendsModule,
	ZkCheckoutNextStepsModule,
	ZkCheckoutPaymentMethodsModule,
	ZkCheckoutPaymentSecureModule,
	ZkCheckoutProductsModule,
	ZkCheckoutSuccessModule,
	ZkCheckoutSuggestedModule,
	ZkCheckoutSummaryModule,
	ZkCheckoutVoucherModule,
	ZkCurrencyPipeModule,
	ZkIconModule,
} from '@zenklub/ng-ui';
import { MarkdownModule } from 'ngx-markdown';

import { CheckoutItemsComponent } from './checkout-items/checkout-items.component';
import { CheckoutSuccessComponent } from './checkout-success/checkout-success.component';
import { CheckoutComponent } from './checkout/checkout.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forChild([
			{
				path: 'checkout',
				component: CheckoutComponent,
			},
		]),
		TranslateModule.forChild(),
		MarkdownModule,

		// NG-UI
		ZkCheckoutContainerModule,
		ZkCheckoutInviteFriendsModule,
		ZkCheckoutNextStepsModule,
		ZkCheckoutPaymentMethodsModule,
		ZkCheckoutPaymentSecureModule,
		ZkCheckoutProductsModule,
		ZkCheckoutSuccessModule,
		ZkCheckoutSuggestedModule,
		ZkCheckoutSummaryModule,
		ZkCheckoutVoucherModule,
		ZkCurrencyPipeModule,
		ZkIconModule,
		FontAwesomeModule,
	],
	declarations: [
		CheckoutItemsComponent,
		CheckoutComponent,
		CheckoutSuccessComponent,
	],
})
export class CheckoutModule {}
